export enum SearchErrorType {
  NO_RESULTS = "no_results",
  NOT_FOUND = "not_found",
  UNAUTHORIZED = "unauthorized",
  SERVER_ERROR = "server_error",
  TIME_OUT_ERROR = "time_out_error",
  UNKNOWN_ERROR = "unknown_error",
  /** No geofencing area configured — the embeddings API requires one */
  GEOFENCING_REQUIRED = "geofencing_required",
  /** Configured geofencing area is above the maximum the embeddings API can process */
  GEOFENCING_AREA_TOO_LARGE = "geofencing_area_too_large",
}
